import React from 'react';

import Box from '../box/box';
import Container from '../container/container';
import Heading from '../heading/heading';
import Text from '../text/text';

interface TemplateHubHeroProps {
  title: string;
  subtitle?: string;
}

const TemplateHubHero: React.FC<TemplateHubHeroProps> = ({ title, subtitle }) => (
  <Box
    css={theme => ({
      backgroundColor: theme.colors.coolGrey[10],
      padding: `${theme.space.s64}px 0`,
    })}
  >
    <Container css={{ textAlign: 'center' }}>
      <Box css={{ margin: '0 auto', maxWidth: '800px' }}>
        <Heading as="h1" variant="hero3XL700">
          {title}
        </Heading>
        {subtitle && (
          <Text css={{ marginBottom: 0 }} variant="paragraphL400">
            {subtitle}
          </Text>
        )}
      </Box>
    </Container>
  </Box>
);

export default TemplateHubHero;
